import React from "react";
import { CalendarClock } from "lucide-react";
import { formatDateOnly } from "@/lib/date";

// Member-facing due-date chip ("Due 11/01/2026 · Our Town").
export default function BioDueChip({ deadline, testId = "bio-due-chip" }) {
  if (!deadline) return null;
  const tone = deadline.overdue ? "bg-red-50 text-red-700 ring-red-200" : "bg-sky-50 text-sky-800 ring-sky-200";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${tone}`} data-testid={testId}>
      <CalendarClock className="h-3.5 w-3.5" />
      {deadline.overdue ? "Past due" : "Due"} {formatDateOnly(deadline.due_date)}{deadline.scope_name ? ` · ${deadline.scope_name}` : ""}
    </span>
  );
}
